import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/insights" element={<Blog />} />
      <Route path="/insights/:slug" element={<BlogPost />} />
      <Route path="*" element={<Home />} /> {/* Fallback to home */}
    </Routes>
  );
}

export default AppRouter;